// Sistema de diseño cerrado de Reportes Recepción. Un color = un significado — nunca
// asignar colores "por variedad" a categorías sin semántica (ahí van todas COLOR.azul).

// Alineado con los tokens del sistema (style/global/index.css y utils/graficos.js).
export const COLOR = {
    azul: '#2563eb',       // --primary
    azulClaro: '#93c5fd',
    verde: '#15803d',      // --success-solid
    verdeClaro: '#4ade80',
    ambar: '#d97706',      // --warning-solid
    rojo: '#dc2626',       // --danger-solid
    rojoClaro: '#f87171',
    negro: '#0f172a',      // --ink
    gris: '#e2e8f0',       // --border
    grisTexto: '#64748b',  // --text-muted
    grisFrio: '#94a3b8',   // --text-disabled
};

export const COLOR_ESTADO = {
    verdeFondo: '#dcfce7', verdeTexto: '#166534',   // --success-bg / --success-text
    ambarFondo: '#fef3c7', ambarTexto: '#92400e',   // --warning-bg / --warning-text
    rojoFondo: '#fee2e2', rojoTexto: '#991b1b',     // --danger-bg / --danger-text
};

export const FUENTE = "'Public Sans', Helvetica, Arial, sans-serif";
export const FUENTE_MONO = "'IBM Plex Mono', 'Courier New', monospace";

// Umbrales del sistema (sección 16 de la spec) — usados tanto para colorear valores
// como para generar Insights/AccionesSugeridas. Nunca se hardcodean sueltos en un
// componente: todo el mundo importa de acá.
//
// Las metas de asistencia y conversión se recalibraron con los datos reales del 20/08 al 20/09/2026.
// OJO: se midieron con definiciones que el 28-sep volvieron a cambiar (la asistencia ahora cuenta los
// sobreturnos: ~50 % en vez de ~46 %; la conversión es sobre las atenciones finalizadas, sin los tipos
// que no son atención al público). Revisarlas con el estudio. Con las definiciones nuevas las metas viejas (80 % y 6 %) dejaban la asistencia
// siempre en rojo y la conversión siempre en verde: no distinguían nada. Son metas de negocio: se
// cambian acá y en ningún otro lado.
//
// Asistencia: el estudio está en ~46 % de forma estable y los canales que no son el bot llegan a ~68 %,
// así que 60 % es alcanzable. Rojo por debajo de 45 %: peor que el punto de partida.
const EFECTIVIDAD = { bueno: 60, alerta: 45 };

export const UMBRALES = {
    efectividad: EFECTIVIDAD,                     // ≥60 verde, 45-60 ámbar, <45 rojo
    // Complemento exacto de la asistencia (suman 100): no se define aparte para que no puedan contradecirse.
    ausentismo: { bueno: 100 - EFECTIVIDAD.bueno, alerta: 100 - EFECTIVIDAD.alerta }, // ≤40 verde, 40-55 ámbar, >55 rojo
    esperaMin: { bueno: 15, alerta: 30 },         // ≤15 verde, 15-30 ámbar, >30 rojo
    ocupacionPct: { bueno: [70, 90], alerta: 100 }, // 70-90 verde, 90-100 ámbar, >100 rojo (y <70 ocioso)
    // Conversión sobre las atenciones finalizadas (no sobre todos los turnos): 31 % en el período
    // completo y 41 % en septiembre de 2026.
    conversionPct: { bueno: 40, alerta: 30 },     // ≥40 verde, 30-40 ámbar, <30 rojo
    muestraMinima: 20,                             // n < 20: no mostrar % (dato ciego)
    // Turnos ANSES tiene su propio umbral, más bajo. La unidad ahí es la presentación por tipo
    // de trámite y el ciclo es largo: con 20, 8 de los 9 tipos mostraban "—" y el corte
    // principal del reporte quedaba en blanco. Tiene que coincidir con MUESTRA_MINIMA de
    // ReportesAnsesService, que es quien decide de verdad (la pantalla solo lo explica).
    muestraMinimaAnses: 10,
};

export const capacidadDefault = 20;

export function colorPorUmbral(valor, { bueno, alerta }, invertido = false) {
    if (valor === null || valor === undefined) return COLOR.grisFrio;
    if (!invertido) {
        // más alto = mejor (efectividad, conversión)
        if (valor >= bueno) return COLOR.verde;
        if (valor >= alerta) return COLOR.ambar;
        return COLOR.rojo;
    }
    // más bajo = mejor (ausentismo, espera)
    if (valor <= bueno) return COLOR.verde;
    if (valor <= alerta) return COLOR.ambar;
    return COLOR.rojo;
}
